import { Handle, Position } from 'reactflow';
import { NodeProps } from 'reactflow';
import { Phase } from '../../configLookup/components/Props';
import styles from "../configInfo.module.css";
import { VegaCard, VegaFlex, VegaFont } from '@globalpayments/vega-react';

function PhaseNode({ data }: NodeProps<Phase>) {
    let phaseName = ' ';

    if(data.headerHtml === null || data.headerHtml === ''){
        phaseName = data.name
    } else {
        phaseName = data.headerHtml.replace(/<\/?[^>]+(>|$)/g, "");
    }

    if(phaseName.length > 75) {
        phaseName = phaseName.slice(0, 75 - phaseName.length)
        phaseName += '...'
    }
    
    return (
        <div>
            <Handle type='target' position={Position.Top} isConnectable={false}/>
                <div className={data.visibilityCriteria ? styles.redBorder : undefined}>
                    <VegaCard className={styles.phaseNode} padding="size-16" variant="border">
                        <VegaFlex direction="col" gap="size-8">
                            <VegaFont as="h3" color="text-primary" variant="font-h5">{phaseName}</VegaFont>
                            <VegaFont as="p" color="text-primary" variant="font-p2-short">Ordinal: {data.ordinal}</VegaFont>
                        </VegaFlex>
                    </VegaCard>
                    <Handle type='source' position={Position.Bottom} isConnectable={false}/>
                </div>
        </div>
    )
}

export default PhaseNode;